import Vue from 'vue'
import VueI18n from 'vue-i18n'
import merge from 'lodash/merge'

const messages = require('./lang/sv.json')
const vuetifylang = process.env.NODE_ENV === 'test' ? {} : require('vuetify/lib/locale/sv.js')
merge(messages, {'sv': {'$vuetify': vuetifylang.default}})

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'sv',
  messages
})

export default i18n
